import React from 'react';
import { useState, useContext, createRef, useEffect } from 'react';
import { AppState } from '../context';

import { Header, Menu, Segment, Grid } from 'semantic-ui-react';
import { useLocation, Link } from 'react-router-dom';

const TopMenu = () => {
  const someContext = useContext(AppState);
  const {
    user
  } = someContext;

  const location = useLocation();
  console.log(user);
  return (
    <Segment 
    basic
    clearing
    style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
    fluid="true">
    <Menu pointing compact>
      <Menu.Item
        name="Tasks"
        icon='tasks'
      
        active={location.pathname === "/familymembers" | location.pathname === "/familymembers/edit/:taskid" | location.pathname === "/familymembers/:userid"}
        as={Link}
        to="/familymembers"
      >
        
        {/* <Header
          as="h4"
          icon='tasks'
          color="black"
          content="Tasks"
        /> */}
      </Menu.Item>
      <Menu.Item 
      icon="clipboard outline"
      name="Summary"
      // active={ user ? location.pathname === `/familymembers/summary/${user["uid"]}` : ""} as={Link} to={ user? `/familymembers/summary/${user["uid"]}` : "/familymembers"}>
      active={ user ? location.pathname === `/familymembers/summary/${user}` : ""} as={Link} to={ user? `/familymembers/summary/${user}` : "/familymembers"}>

        {/* <Header
          as="h4"
          color="black"
          content={"Summary"}
          icon='clipboard outline'
        /> */}
      </Menu.Item>
      <Menu.Item 
      // icon="clipboard outline"
      name="Notes"
      active={ user ? location.pathname === `/familymembers/Notes/${user}` : ""} as={Link} to={ user? `/familymembers/Notes/${user}` : "/familymembers"}>
        {/* <Header
          as="h4"
          color="black"
          content={"Summary"}
          icon='clipboard outline'
        /> */}
      </Menu.Item>

      <Menu.Item 
      icon='user'
      active={ user ? location.pathname === `/familymembers/profile/${user}` : ""} as={Link} to={ user? `/familymembers/profile/${user}` : "/familymembers"}>
        {/* <Header
          as="h4"
          color="black"
          icon='user'
        /> */}
      </Menu.Item>
    </Menu>
    </Segment>
  )
}

{/* // <Menu pointing compact> */}
{/* <Menu.Item
name='home'
active={activeItem === 'tasks'}
onClick={()=>setActiveItem('tasks')}
/>   
<Menu.Item
name='Notes'
active={activeItem === 'notes'}
onClick={()=>setActiveItem('notes')}
/> 
<Menu.Item
name='Others Tasks'
active={activeItem === 'home'}
onClick={()=>setActiveItem('home')}
/>
<Menu.Item
name='Homecare'
style={{
  color: 'white',backgroundColor: "#006990"
}
}
active={false}
// onClick={()=>setActiveItem('tasks')}
/>
</Menu> */}

export default TopMenu

